import React from 'react'
import { MobileMenuHeaderProps } from '../ContentfulNavigation'
import classNames from 'classnames'

const MobileMenuHeader = ({
  handleBackButton,
  handleCloseButton,
  showOnTablet,
  title
}: MobileMenuHeaderProps) => {
  const headerClasses = classNames(
    'flex flex-nowrap justify-between items-center border-b border-gray-25 px-4 py-3',
    {
      'md:hidden': !showOnTablet
    }
  )

  return (
    <div className={headerClasses} data-testid='MobileMenuHeader'>
      <button
        aria-label='Return to Previous Menu'
        className='before:content-icon-chevron-left before:h-6 before:w-6 relative top-1'
        onClick={handleBackButton}
      />
      <h4 className='font-effra text-[22px] leading-8'>{title}</h4>
      <button
        aria-label='Close Mobile Navigation'
        className='w-5 h-5'
        onClick={handleCloseButton}
      >
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out rotate-45'
        />
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out opacity-0'
        />
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out -rotate-45'
        />
      </button>
    </div>
  )
}

export default MobileMenuHeader
